import { render, staticRenderFns } from "./string-translation.vue?vue&type=template&id=0127072e&"
import script from "./string-translation.vue?vue&type=script&lang=js&"
export * from "./string-translation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports